<template>
  <div id="app" :key="reload">
    <topHeader/>
    <navbar/>
    <infoBar @reload="rld"/>
    <router-view @modalOpen="openModal"/>
    <modal
    v-if="modalOpen===true"
    @closeModal="modalClose"
    :PhotoSource="modal.photo"
    :username="modal.name"
    :description="modal.desc"
    :Website="modal.website"
    />
    <div style="height: 2vw;"></div>
  </div>
</template>

<script>
import topHeader from '@/components/topHeader.vue';
import infoBar from '@/components/infoBar.vue';
import navbar from '@/components/navbar.vue';
import modal from '@/components/modal.vue';

export default {
  components: {
    topHeader,
    infoBar,
    navbar,
    modal,
  },

  data() {
    return {
      reload: 0,
      modalOpen: false,
      modal: {
        photo: '',
        desc: '',
        name: '',
        website: 'none',
      },
    };
  },

  methods: {
    openModal(photo, description, name, website) {
      this.modal.photo = photo;
      this.modal.desc = description;
      this.modal.name = name;
      this.modal.website = website;
      this.modalOpen = true;
      const el = document.body;
      el.classList.add('modal-open');
    },

    modalClose() {
      this.modal.photo = '';
      this.modal.desc = '';
      this.modal.name = '';
      this.modal.website = 'none';
      this.modalOpen = false;
      const el = document.body;
      el.classList.remove('modal-open');
    },

    rld() {
      if (this.reload > 2) {
        this.reload = 0;
      } else {
        this.reload += 1;
      }
    },
  },
};
</script>

<style>

*{
  margin: 0;
  padding: 0;
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif
}

body {
  background:rgb(90,105,207);
}

body.modal-open {
  overflow: hidden;
  height: 100vh;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  width: 80%;
  margin: 0 auto;
  padding-left: calc(100vw - 100%);
}
::-webkit-scrollbar {
  width: 0.15vw;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #ffffff;
  border-radius: 50px;
}
::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}
::-webkit-scrollbar-thumb:active {
  background: #ffffff;
  cursor: pointer;
}
::-webkit-scrollbar-track {
  background: transparent;
]  border-radius: 50px;
}
::-webkit-scrollbar-track:hover {
  background: transparent;
}
::-webkit-scrollbar-track:active {
  background: transparent;
}
::-webkit-scrollbar-corner {
  background: transparent;
}
</style>
